import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const getAsset = (state) =>{

  return axios.get(API + "contracts/asset-edit/"+state+"/",{headers: authHeader(),});
};

const addAsset = (state,asset_number, asset_desc, license_number,financed_amount, year,vin_number,license_state,dealer_payable,manufacturer,make,model,user_purpose,residal_value,reg_address,vendor_name,delivery_date,in_service_date,milage,vehicle_cost,vehicle_cost_payto,tax_amount,
  tax_amount_payto,trade_in,trade_in_payto,reg_cost,reg_cost_payto,total_cost,down_payment,down_payment_payto,assettype,attribute,item_master_id, condition,
    vendor_asset_Id,
    salvage_value,) => {
  return axios.post(API + "contracts/asset-edit/"+state+"/", {
  asset_number,
  asset_desc,
  license_number,
  financed_amount,
  year,
  vin_number,
  license_state,
  dealer_payable,
  manufacturer,
  make,
  model,
  user_purpose,
  residal_value,
  reg_address,
  vendor_name,
  delivery_date,
  in_service_date,
  milage,
  vehicle_cost,
  vehicle_cost_payto,
  tax_amount,
  tax_amount_payto,
  trade_in,
  trade_in_payto,
  reg_cost,
  reg_cost_payto,
  total_cost,
  down_payment,
  down_payment_payto,
  assettype,
  attribute,
  item_master_id,
  condition,
  vendor_asset_Id,
  salvage_value,
},{headers: authHeader(),});
};


const EditAssetService = {
    getAsset,
    addAsset,
};
export default EditAssetService;